import { useQuery, UseQueryOptions } from 'react-query'

import { useSitesContext } from '../../components/SitesProvider'
import request from '../../config/axios'
import QueryKeys from './QueryKeys'

interface SurveyResponseGroupsResponse {
  surveyResponseGroups: SurveyResponseGroup[]
}

export interface SurveyResponseGroup {
  id: string
  availableOn: string
  expiresOn: string
  ownerType: 'Patient'
  ownerId: string
  shortLink: string
  firstCaseId?: string
}

interface SurveyResponseGroupsParams {
  patientId?: string
}

const useSurveyResponseGroups = (
  { patientId }: SurveyResponseGroupsParams,
  extraOptions: UseQueryOptions<SurveyResponseGroup[]> = {},
) => {
  const currentSite = useSitesContext().currentSite
  const currentSiteId = currentSite?.id || ``

  const key = QueryKeys.surveyResponseGroups({
    currentSiteId,
    patientId,
  })

  const url = `/impacts/survey_response_groups?site_ids[]=${currentSiteId}`

  return useQuery(
    key,
    () =>
      request
        .get<SurveyResponseGroupsResponse>(url, {
          params: {
            patient_id: patientId,
          },
        })
        .then((r) => r.data.surveyResponseGroups),
    {
      ...extraOptions,
    },
  )
}

export default useSurveyResponseGroups
